import { useTranslation } from '@thoughtspot/i18n';
import { ContentGrid } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator/loading-indicator';
import { isThirdPartyAnalysisEnabled } from '@thoughtspot/session-service';
import React from 'react';
import { ConfigPrePostFixStrings } from '../../settings/common';
import { MLIntegrationsContainerAdmin } from '../../spotiq/ml-integration/mlIntegration.container';
import { SectionContainer } from '../config-components';
import { ConfigRow } from './config-row';
import { COUNT_NULL_KEYS, DATE_BUCKET_BACKEND_DEFAULT, DATE_BUCKET_KEY, VIRTUAL_COUNT_NULL, } from './constants';
const tOrUndefined = (translated, key) => translated !== key ? translated : undefined;
const normalizeConfigValue = (config) => {
    if (config.configName === DATE_BUCKET_KEY &&
        (config.value === DATE_BUCKET_BACKEND_DEFAULT ||
            config.value === 'Detailed')) {
        return { ...config, value: 'default' };
    }
    return config;
};
const transformConfigs = (configs, settingName) => {
    if (settingName !== 'querySetting') {
        return configs.map(normalizeConfigValue);
    }
    const remaining = configs
        .filter(c => !COUNT_NULL_KEYS.includes(c.configName))
        .map(normalizeConfigValue);
    const allEnabled = COUNT_NULL_KEYS.every(key => configs.find(c => c.configName === key)?.value === 'true');
    const virtualToggle = {
        configName: VIRTUAL_COUNT_NULL,
        elementType: 'toggle',
        value: allEnabled ? 'true' : 'false',
        controlsFlags: COUNT_NULL_KEYS,
    };
    return [...remaining, virtualToggle];
};
export const SearchSpotIQTab = ({ group, isLoading, viewMode, isModernFMEnabled, onSave, onReset, onSaveOrgAware, onPreserveOverrideNeeded, }) => {
    const { t } = useTranslation();
    const content = (React.createElement(React.Fragment, null,
        (group?.settings ?? []).map(setting => {
            if (!setting)
                return null;
            const rawConfigs = (setting.configs ?? []).filter((c) => Boolean(c));
            if (rawConfigs.length === 0)
                return null;
            const configs = transformConfigs(rawConfigs, setting.settingName);
            const sectionTitle = t(`${setting.settingName}.${ConfigPrePostFixStrings.TITLE}`);
            const sectionSubTitleKey = `${setting.settingName}.${ConfigPrePostFixStrings.SUBTITLE}`;
            const sectionSubTitle = tOrUndefined(t(sectionSubTitleKey), sectionSubTitleKey);
            return (React.createElement(SectionContainer, { key: setting.settingName, "data-testid": setting.settingName, title: sectionTitle, description: sectionSubTitle, isCollapsible: configs.length > 1, onReset: setting.resetToDefault === 'true' &&
                    viewMode === 'all'
                    ? () => onReset(configs.flatMap(c => c.controlsFlags ?? [
                        c.configName,
                    ]))
                    : undefined }, configs.map(config => (React.createElement(ConfigRow, { key: config.configName, config: config, viewMode: viewMode, isModernFMEnabled: isModernFMEnabled, onSave: onSave, onSaveOrgAware: onSaveOrgAware, onPreserveOverrideNeeded: onPreserveOverrideNeeded })))));
        }),
        isThirdPartyAnalysisEnabled() && React.createElement(MLIntegrationsContainerAdmin, null)));
    return (React.createElement(LoadingIndicator.Global, { hideLoader: !isLoading },
        React.createElement(ContentGrid, { as: "section", span: 10, grow: true }, content)));
};
//# sourceMappingURL=search-spotiq-tab.js.map